export function evaluateCondition(condition, row) {
  if (!condition || !condition.column) return false;
  const cellVal = row[condition.column];
  const raw = cellVal?.value !== undefined ? cellVal.value : cellVal;
  const strVal = raw == null ? '' : String(raw);
  const numVal = Number(raw);
  const cmpVal = condition.value;

  switch (condition.operator) {
    case '=':  return strVal === String(cmpVal);
    case '!=': return strVal !== String(cmpVal);
    case '>':  return !isNaN(numVal) && numVal > Number(cmpVal);
    case '<':  return !isNaN(numVal) && numVal < Number(cmpVal);
    case '>=': return !isNaN(numVal) && numVal >= Number(cmpVal);
    case '<=': return !isNaN(numVal) && numVal <= Number(cmpVal);
    case 'contains':     return strVal.toLowerCase().includes(String(cmpVal).toLowerCase());
    case 'not_contains': return !strVal.toLowerCase().includes(String(cmpVal).toLowerCase());
    case 'is_empty':     return raw == null || strVal === '';
    case 'is_not_empty': return raw != null && strVal !== '';
    default: return false;
  }
}

export function getTableCellStyle(colorRules, row, rowIndex, columnName) {
  if (!colorRules?.length) return null;
  let bg = null;
  let text = null;

  for (const rule of colorRules) {
    let matches = false;
    if (rule.condition?.column) {
      matches = evaluateCondition(rule.condition, row);
    } else if (rule.target === 'column' && rule.column === columnName) {
      matches = true;
    } else if (rule.target === 'row' && rule.rowIndex === rowIndex) {
      matches = true;
    }
    if (matches) {
      if (rule.target === 'column' && columnName !== rule.column && !rule.condition) continue;
      if (rule.backgroundColor) bg = rule.backgroundColor;
      if (rule.textColor) text = rule.textColor;
    }
  }
  if (!bg && !text) return null;
  return { backgroundColor: bg || undefined, color: text || undefined };
}

export function getTableHeaderStyle(colorRules, columnName) {
  if (!colorRules?.length) return null;
  for (const rule of colorRules) {
    if (rule.target === 'column' && rule.column === columnName && !rule.condition?.column) {
      if (rule.backgroundColor) {
        return { backgroundColor: rule.backgroundColor, color: rule.textColor || undefined };
      }
    }
  }
  return null;
}
